import { ELkType } from '../../repositories/lk-type/entities/get_lk_type_v2/GetLkTypeResponseV2';
import { IApplicationState } from '../../types/redux';

export const getIsAgent = (state: IApplicationState): boolean => {
  return state.lkType === ELkType.Specialist;
};
